/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorizationOAuthAppDetails } from './authorizationOAuthAppDetails';


export interface AuthorizationOAuthAppValidity { 
    /**
     * Suggests if authorization OAuth app is valid or not.
     */
    valid?: boolean;
    valid_authorization_oauth_app_details?: AuthorizationOAuthAppDetails;
}

